import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { Grid, GridCell } from '../Grid';
import Headline3 from '../Typography/Heading/Headline3';
import { Breadcrumbs } from '../Breadcrumb';

const listPagePropertyTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.node).isRequired,
  title: PropTypes.string.isRequired,
  topSlot: PropTypes.node,
  filters: PropTypes.node,
  list: PropTypes.node.isRequired,
};

type ListPageProperties = InferProps<typeof listPagePropertyTypes>;

const ListPage = ({
  breadcrumbs,
  title,
  topSlot,
  filters,
  list,
}: ListPageProperties) => (
  <Grid container spacing={5}>
    <GridCell padding="0 0 20px 38px">
      <Breadcrumbs crumbs={breadcrumbs} />
    </GridCell>
    <GridCell padding="20px 36px">
      <Headline3 tag="h1">{title}</Headline3>
    </GridCell>
    { topSlot && (
      <GridCell padding="0 36px">
        {topSlot}
      </GridCell>
    )}
    <GridCell padding="0 36px">
      {filters}
    </GridCell>
    <GridCell padding="4px 20px">
      {list}
    </GridCell>
  </Grid>
);

ListPage.propTypes = listPagePropertyTypes;

ListPage.defaultProps = {
  topSlot: undefined,
  filters: undefined,
};

export default ListPage;
